import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import Overlay from './components/overlay'
import './overlay-attachments.css'

const OverlayAttachments = ({ name, overlayType, overlayMediaId }) => (
  <div>
    <div className='br-dm-attachments overlay-component col-xs-12'>
      <ul role='tablist' className='nav nav-tabs'>
        <li role='presentation'>
          <Field
            id={`${name}.image`}
            name={`${name}.overlayType`}
            component='input'
            type='radio'
            value='OVERLAY_IMAGE'
            checked={overlayType === 'OVERLAY_IMAGE'}
            disabled={overlayMediaId}
            hidden
          />

          <label htmlFor={`${name}.image`}>Image overlay</label>
        </li>
        <li role='presentation'>
          <Field
            id={`${name}.gif`}
            name={`${name}.overlayType`}
            component='input'
            type='radio'
            value='OVERLAY_GIF'
            disabled={overlayMediaId}
            hidden
          />

          <label htmlFor={`${name}.gif`}>GIF overlay</label>
        </li>
      </ul>

      <Overlay
        name={`${name}`}
        overlayType={overlayType}
        overlayMediaId={overlayMediaId}
      />
    </div>
  </div>
)

OverlayAttachments.propTypes = {
  name: PropTypes.string,
  overlayType: PropTypes.string,
  overlayMediaId: PropTypes.array
}

export default OverlayAttachments



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-overlay/overlay-attachments/index.js